/**
 * Internal dependencies
 */
import API from '@naruto/bgdcms/src/api';
import Env from '@naruto/bgdcms/src/env';
import { CreateMiddleWareProps, MiddleWare } from './types';

function initializeMiddleware(props: CreateMiddleWareProps): MiddleWare {
  const APIInstance = new API(props.apiConfig);
  const ENVInstance = Env;
  return {
    api: APIInstance,
    env: ENVInstance
  };
}

export default initializeMiddleware;
